export const ERROR_IMAGE_ID = "empty_500_3x_au34cg";
export const ERROR_IMAGE_ID_UX4 = "4_0_Assets/ux4_empty_cart_500";
export const TOING_ERROR_IMAGE_ID = "Toing/Error%20States/Internal%20Server%20Error.png";

export const DEFAULT_ERROR_MESSAGE = "Sorry! This should not have happened. Please retry.";
export const DEFAULT_ERROR_TITLE = "Uh-oh!";
export const RETRY = "Retry";
export const TRY_AGAIN = "Try Again";

export const DATA_TEST_ID = {
    ERROR_TITLE: "error-title",
    ERROR_PRIMARY_ACTION: "error-primary-action",
    ERROR_SECONDARY_ACTION: "error-secondary-action",
    ERROR_BACK_BUTTON: "error-back-button",
};
